import type { ExperienceHistoryFromBackend, PaginationDataToBackend } from './types';

import { URL } from '../../../constants';
import { httpApiService } from '../../../utils/create-http-api-service';
import { defaultRequestService } from '../../../utils/default-request-service';

// ---

export const getCashbackExperienceHistory = (
  requestData: PaginationDataToBackend,
) => {
  type AdapterProps = { request: typeof requestData; response: ExperienceHistoryFromBackend[] };

  return defaultRequestService<AdapterProps, void>(
    URL.CASHBACK_EXPERIENCE_HISTORY,
    httpApiService.post,
    {
      requestData,
    },
  );
};

